import React, { lazy, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import LottieLoader from "./lottie/lottie.jsx";

// Lazy load del TVChartContainer
const TVChartContainer = lazy(() =>
	import("./pages/index").then((module) => ({
		default: module.default || module.TVChartContainer,
	}))
);

const App = () => {
	return (
		<>
			<ToastContainer />
			<Suspense fallback={<LoadingScreen />}>
				<TVChartContainer />
			</Suspense>
		</>
	);
};

const LoadingScreen = () => (
	<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
		<LottieLoader />
	</div>
);

export default App;
